import {Language} from "modules/enums";
import logoEn from "assets/images/logo.png";
import logoFr from "assets/images/logo-fr.png";
import headerLogoEn from "assets/images/header-logo.png";
import headerLogoFr from "assets/images/header-fr-logo.png";

export const ENV = process.env.REACT_APP_ENVIRONMENT;
export const BASE_URL = process.env.REACT_APP_BASE_URL || "";
export const API_URL = process.env.REACT_APP_API_URL || "";
export const FANTASY_API_URL = process.env.REACT_APP_FANTASY_API_URL || "";
export const JSON_URL = process.env.REACT_APP_JSON_URL || "";
export const IMAGES_URL = process.env.REACT_APP_IMAGES_URL || "";
export const STORAGE_VERSION = 1;

export const logoLinks = {
	en: "https://cfl.ca/",
	fr: "https://www.lcf.ca/",
};

export const logos = {
	[Language.English]: logoEn,
	[Language.French]: logoFr,
};

export const headerLogos = {
	[Language.English]: headerLogoEn,
	[Language.French]: headerLogoFr,
};

export * from "./socialNetworkLinks";
export * from "./routing";
export * from "./regexs";
export * from "./helpPagesRouting";
export * from "./subMenuRouting";
